import { render, staticRenderFns } from "./relic-detail-base-upload.vue?vue&type=template&id=f8b6407c"
import script from "./relic-detail-base-upload.vue?vue&type=script&lang=js"
export * from "./relic-detail-base-upload.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-base-upload.vue?vue&type=style&index=0&id=f8b6407c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports